import type { ReactNode } from "react";
import { ResponsivePopover } from "./ResponsivePopover.tsx";

export const ContextFilter = ({
	activeCount,
	children,
}: {
	activeCount?: number;
	children?: ReactNode;
}) => {
	return (
		<div
			data-mobile-context-filter=""
			data-mobile-context-filter-count={activeCount ?? 0}
		>
			{children}
		</div>
	);
};

export const FilterSheet = ({
	activeCount,
	children,
	id,
	renderTarget,
	title,
}: {
	activeCount?: number;
	children: ReactNode;
	id: string;
	renderTarget: Parameters<typeof ResponsivePopover>[0]["renderTarget"];
	title: ReactNode;
}) => {
	const body = (
		<div
			data-mobile-filter-sheet=""
			data-mobile-filter-sheet-count={activeCount ?? 0}
		>
			{children}
		</div>
	);

	return (
		<ResponsivePopover
			id={id}
			modalHeader={title}
			modalBody={body}
			popoverContent={body}
			renderTarget={renderTarget}
		/>
	);
};
